module.exports = __webpack_public_path__ + "static/media/paper-plane.fe662890.svg";